import axios from "axios";
const jsonConfig = require("../../Config.json");
const getvetviolations = async (id) => {
  try {
    const response = await axios.get(
      `${jsonConfig.apiUrl}vetcandidateviolation`,
      {
        headers: {
          "x-functions-key": jsonConfig.key,
        },
        params: {
          cid: id,
        },
      }
    );
    return response;
  } catch (error) {
    return Promise.reject(error);
  }
};
export default getvetviolations;